/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const OrientationPortraitIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Orientation Portrait',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10,10.06445c-1.5127,0-2.74414-1.2334-2.74414-2.75s1.23145-2.75,2.74414-2.75,2.74414,1.2334,2.74414,2.75-1.23145,2.75-2.74414,2.75ZM10,6.06445c-.68555,0-1.24414.56055-1.24414,1.25s.55859,1.25,1.24414,1.25,1.24414-.56055,1.24414-1.25-.55859-1.25-1.24414-1.25Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M14.75,1H5.25c-1.24023,0-2.25,1.00977-2.25,2.25v12.5c0,1.24023,1.00977,2.25,2.25,2.25h9.5c1.24023,0,2.25-1.00977,2.25-2.25V3.25c0-1.24023-1.00977-2.25-2.25-2.25ZM8.31445,12.5752c1.08594.42285,2.29297.41992,3.37305-.00098,1.0481.64526.97168,2.96631.83765,3.92578h-5.04443c-.06006-.39209-.43481-3.19116.83374-3.9248ZM15.5,15.75c0,.41309-.33691.75-.75.75h-.71313c.12524-1.146.30298-4.6582-2.10718-5.45703-.18652-.06152-.38672-.04883-.55957.03516-.87012.41602-1.8623.41699-2.73535.00293-.1748-.08203-.37207-.09473-.55664-.03418-2.51147.82812-2.25391,4.36914-2.11255,5.45312h-.71558c-.41309,0-.75-.33691-.75-.75V3.25c0-.41309.33691-.75.75-.75h9.5c.41309,0,.75.33691.75.75v12.5Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
